import { eventingApi } from '../../../../../services/eventingApi';
import { useApiResource } from '../hooks/useApiResource';
import ResourceState from '../shared/ResourceState';
import DeadLetterMessage from './DeadLetterMessage';

const DeadLetterMessages = ({ consumer }: { consumer: string }) => {
  const messages = useApiResource(() => eventingApi.listDeadLetterMessages(consumer), [consumer]);

  return (
    <>
      <ResourceState resource={messages} emptyText="A DLQ está vazia." />
      <ul className="space-y-2">
        {(messages.data ?? []).map((message) => (
          <DeadLetterMessage key={message.messageId} message={message} />
        ))}
      </ul>
    </>
  );
};

export default DeadLetterMessages;
